var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';
import LogDNA from 'helpers/logdna';
import { getCustomBrandingFromStorage, saveCustomBrandingToStorage, getAccountIdFromStorage, } from 'helpers/customBranding';
const SESSION_EMAIL = 'email';
const SESSION_EXAM_CODE = 'code';
const SESSION_KEY = 'session';
const useAuthentication = () => {
    const logger = new LogDNA();
    const createSession = (email, accessCode) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const loginService = `${process.env.REACT_APP_SUMADI_EXAMS_AUTH_SERVICES_URL}/students/auth`;
        const defaultError = 'INVALID_CREDENTIALS';
        try {
            const result = yield axios.post(loginService, {
                email,
                accessCode,
            });
            const sessionToken = (_a = result.data) === null || _a === void 0 ? void 0 : _a.accessToken;
            if (!sessionToken) {
                return {
                    error: defaultError,
                };
            }
            localStorage.setItem(SESSION_KEY, sessionToken);
            localStorage.setItem(SESSION_EMAIL, email);
            localStorage.setItem(SESSION_EXAM_CODE, accessCode.toString());
            return {
                accessToken: sessionToken,
            };
        }
        catch (e) {
            logger.error(e);
            const error = e;
            const errorText = (_d = (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) !== null && _d !== void 0 ? _d : defaultError;
            return {
                error: errorText,
            };
        }
    });
    /**
     * Return the current session token
     */
    const getSessionToken = () => {
        return localStorage.getItem(SESSION_KEY);
    };
    const logout = (callback) => {
        const customBranding = getCustomBrandingFromStorage();
        const accountId = getAccountIdFromStorage();
        localStorage.clear();
        saveCustomBrandingToStorage(customBranding, accountId);
        if (callback) {
            callback();
        }
    };
    const isLoggedIn = () => {
        const tokenDecoded = getTokenDecoded();
        if (!tokenDecoded) {
            return false;
        }
        const currentTimestamp = Math.round(+new Date() / 1000);
        return currentTimestamp < tokenDecoded.exp;
    };
    const getSessionEmail = () => {
        return localStorage.getItem(SESSION_EMAIL);
    };
    const getExamCode = () => {
        return Number(localStorage.getItem(SESSION_EXAM_CODE));
    };
    const getTokenDecoded = () => {
        const sessionToken = getSessionToken();
        if (!sessionToken) {
            return undefined;
        }
        try {
            const decodedToken = jwt_decode(sessionToken);
            return decodedToken;
        }
        catch (error) {
            logger.error(error);
            return undefined;
        }
    };
    const getExamIdFromToken = () => {
        const decodedToken = getTokenDecoded();
        if (decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.examId) {
            return Number(decodedToken.examId);
        }
        return null;
    };
    const getUserIdFromToken = () => {
        const decodedToken = getTokenDecoded();
        if (decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.userId) {
            return Number(decodedToken.userId);
        }
        return null;
    };
    const getUserNameFromToken = () => {
        const sessionToken = getSessionToken();
        if (sessionToken) {
            try {
                const decodeToken = jwt_decode(sessionToken);
                if ((decodeToken === null || decodeToken === void 0 ? void 0 : decodeToken.firstName) && (decodeToken === null || decodeToken === void 0 ? void 0 : decodeToken.lastName)) {
                    return decodeToken.firstName.concat(' ', decodeToken.lastName);
                }
            }
            catch (error) {
                logger.error(error);
                throw new Error('Invalid jwt');
            }
        }
        return null;
    };
    return {
        createSession,
        getSessionToken,
        logout,
        isLoggedIn,
        getSessionEmail,
        getExamCode,
        getExamIdFromToken,
        getUserIdFromToken,
        getUserNameFromToken,
    };
};
export default useAuthentication;
